import { render, staticRenderFns } from "./Users-Create.vue?vue&type=template&id=0940aaab&scoped=true&"
import script from "./Users-Create.vue?vue&type=script&lang=js&"
export * from "./Users-Create.vue?vue&type=script&lang=js&"
import style0 from "./Users-Create.vue?vue&type=style&index=0&id=0940aaab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0940aaab",
  null
  
)

export default component.exports